import { getjQuery } from "@serenity-is/corelib";

(() => {
    const jq = getjQuery();
    if (!jq)
        return;

    // force Monday as first day of the week for all datepickers
    // matchingit #855
    jq.datepicker.setDefaults({
        firstDay: 1 // Monday
    });
})()